import InvoiceStatus from "@/usecases/accounting/invoice-status";

const locale = {
  jp: {
    [InvoiceStatus.Created]: "未請求",
    [InvoiceStatus.Requested]: "請求済み",
    [InvoiceStatus.Paid]: "入金済み"
  }
};

export default {
  toJp(key: string): string {
    return locale.jp[key] || "";
  }
};
